import React from "react";

import { SimpleEmployerBreadcrumbs } from "EmployerDashboard/Components/Breadcrumbs";
import { Link, RouteComponentProps } from "react-router-dom";

import Chrome from "../components/Chrome";
import Layout from "../components/Layout";
import { CardSection } from "Cobalt/Card";
import DashboardHeader from "Common/DashboardHeader";
import { Li, Ul } from "Common/HTML";
import BodyText from "Theme/BodyText";
import { LinkButton } from "Theme/Button";

const ProcessingPlansPage: React.FC<RouteComponentProps<{}>> = () => (
  <Chrome title="SimplyInsured - Broker Dashboard">
    <Layout>
      <SimpleEmployerBreadcrumbs title="Broker Plan Upload Complete" px={0} />
      <DashboardHeader title="What Happens Next" subtitle="We are currently processing your plans. We will notify you when they are ready." px={0} />
      <CardSection title="Next Steps" px={0}>
        <BodyText>
          Once we process the plans the 'Begin Renewal' flow will be available for you or the Employer to complete.
          <br />
          There you will be able to:
          <Ul pl={4}>
            <Li>Set company contributions</Li>
            <Li>Send employee applications</Li>
            <Li>Monitor status of employee applications</Li>
            <Li>Upload any additional documents required by the carrier</Li>
          </Ul>
        </BodyText>
      </CardSection>
      <CardSection className="flex" px={0}>
        <LinkButton component={Link} size="medium" to="/employer-dashboard" ml="auto">
          Back to Dashboard
        </LinkButton>
      </CardSection>
    </Layout>
  </Chrome>
);

export default ProcessingPlansPage;
